import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { verifyEmail } from "../api/api.js";

function Verification() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!code) {
      setStatus("invalid");
      return;
    }

    const checkVerification = async () => {
        try {
            const response = await verifyEmail(code);
            if (response.status === 'success') {
                setStatus("verified");
            } else {
                setStatus("failed");
            }
        } catch (error) {
            setStatus("failed");
        }
    };

    checkVerification();
  }, [code]);

  return (
    <div className="verify-container">
      {status === "loading" && <h2>Verifying email...</h2>}
      {status === "verified" && <h2>Email successfully verified! ✅</h2>}
      {status === "failed" && <h2>Verification failed. ❌</h2>}
      {status === "invalid" && <h2>Invalid verification link. 🚫</h2>}
    </div>
  );
}

export default Verification;
